import { TranslateScope } from  '@/interfaces/languages';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { LanguageContext } from '@/context/LanguageContext';

const QuickTranslateQ2 = () => {

    const radio1 = useRef<HTMLInputElement>(null);
    const radio2 = useRef<HTMLInputElement>(null);

    const languageContext = useContext(LanguageContext);

    // Preselect
    useEffect(() => {

        if (languageContext.store.translateScope !== null && radio1.current && radio2.current){
            
            if (languageContext.store.translateScope === TranslateScope.AllContent){
                radio1.current.checked = true;
            }
            else if (languageContext.store.translateScope === TranslateScope.TranslatedContent){
                radio2.current.checked = true;
            }

        }

    }, [languageContext.store])

    function outerClick(ref:React.MutableRefObject<HTMLInputElement>) {

        if (ref.current){
            ref.current.checked = true;

            const selected = parseInt(ref.current.value) === 1 ? TranslateScope.AllContent : TranslateScope.TranslatedContent;
            
            languageContext.setStore({
                ...languageContext.store, 
                translateScope:selected
            })
        }
    }
    
    return (
        <div className='language-action'>
            
            <p>Please select an automated action. Once you have selected an action, you can review your chosen languages and the action you want to take before automatically translating your content.</p>

            <label onClick={() => outerClick(radio1)}>
                <div>
                    Translate my organisations entire content library (across all workspaces) into my chosen languages.
                </div>
                <div>
                    <input type="radio" name="selection" value={1} ref={radio1} />
                </div>  
            </label>

            <label onClick={() => outerClick(radio2)}>
                <div>
                    Translate content items within my content library (across all workspaces) that already has translations for other languages.
                </div>
                <div>
                    <input type="radio" name="selection" value={2} ref={radio2} />
                </div>
            </label>

        </div>
    );
};

export default QuickTranslateQ2;